"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _CsvHandlerV = _interopRequireDefault(require("./CsvHandlerV2"));

var _LoadingIndicator = _interopRequireDefault(require("../../../components/LoadingIndicator"));

var _actions = require("../../actions");

var _groupedPersona = require("../../actions/groupedPersonas/groupedPersona");

var _loadCommunitiesAndPersonas = require("../../actions/campaignCreator/loadCommunitiesAndPersonas");

var _communities = require("../../reducers/communities");

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectPersonasUpdated = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectPersonasUpdated, _React$Component);

  function SelectPersonasUpdated(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState(_extends({}, _this.state, {
        showSidebar: !_this.state.showSidebar
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckBoxAction", function () {
      _this.props.loadGroupedPersona();
    });

    _this.state = {
      showSidebar: false
    };
    return _this;
  }

  var _proto = SelectPersonasUpdated.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.briefsFlow !== 'find') {
      this.props.setBriefsFlow('find');

      if (this.props.selectedPersonas.length) {
        this.props.resetSelectedPersonas();
      }
    }

    this.props.loadCommunitiesAndPersonas(); // this.props.loadSuperSegments();

    this.props.featureAccess();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        selectedPersonas = _this$props.selectedPersonas,
        campaignCreatorAccess = _this$props.campaignCreatorAccess,
        communities = _this$props.communities,
        isFetchingCommunities = _this$props.isFetchingCommunities,
        setSelectedPersonas = _this$props.setSelectedPersonas;
    var NextButton = /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      style: {
        marginLeft: '1em'
      },
      as: _reactRouterDom.Link,
      onClick: function onClick() {
        _this2.props.setPreviewSelectedPersonas(false);
      },
      to: "message-streams"
    }, "Next");

    var NextButtonTop = function NextButtonTop() {
      return selectedPersonas.length ? NextButton : /*#__PURE__*/React.createElement(_semanticUiReact.Popup, {
        position: "top right",
        content: "You must have uploaded a file with valid personas to proceed to the next page",
        trigger: /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: '1em'
          },
          className: "ui button button--not-validated"
        }, "Next")
      });
    };

    if (isFetchingCommunities || !communities) {
      return /*#__PURE__*/React.createElement(_LoadingIndicator["default"], null);
    }

    return campaignCreatorAccess ? /*#__PURE__*/React.createElement(_semanticUiReact.Container, null, /*#__PURE__*/React.createElement("div", {
      className: "creative-briefs--navigation creative-briefs--navigation__x-pad"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      as: _reactRouterDom.Link,
      to: "getting-started"
    }, "Back"), /*#__PURE__*/React.createElement("h1", {
      className: "campaign-creator--title"
    }, "Upload Your Helix Personas Profile"), /*#__PURE__*/React.createElement(NextButtonTop, null)), /*#__PURE__*/React.createElement("div", {
      className: "campaign-creator-page"
    }, /*#__PURE__*/React.createElement(_CsvHandlerV["default"], {
      setSelectedPersonas: setSelectedPersonas
    }, /*#__PURE__*/React.createElement(NextButtonTop, null)))) : null;
  };

  return SelectPersonasUpdated;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var workflowPermission = state.options.permissions && state.options.permissions.workflowPermission;
  return {
    communities: state.communities && (0, _communities.getCommunitiesSortedAlphabetically)(state),
    isFetchingCommunities: state.communities && state.communities.isFetching,
    selectedPersonas: state.selectedPersonas.personas,
    briefsFlow: state.campaignCreator.briefsFlow,
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedPersonas: _actions.setSelectedPersonas,
    resetSelectedPersonas: _actions.resetSelectedPersonas,
    featureAccess: _index.featureAccess,
    loadGroupedPersona: _groupedPersona.loadGroupedPersona,
    loadCommunitiesAndPersonas: _loadCommunitiesAndPersonas.loadCommunitiesAndPersonas,
    setBriefsFlow: _actions.setBriefsFlow,
    setPreviewSelectedPersonas: _actions.setPreviewSelectedPersonas
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectPersonasUpdated);

exports["default"] = _default;